import React from 'react'
import { ReactComponent as NoPoliciesSVG } from './no_policies_icon.svg'
import { large } from './styles'

export const NoPoliciesIcon = (): JSX.Element => {
  return <NoPoliciesSVG style={large} />
}
